export default __webpack_public_path__ + "static/media/arrow-right.8c5b3d08.svg";